export function checkParameterExistsByName(name:string, url = window.location.href):boolean {
  name = name.replace(/[\[\]]/g, '\\$&'); /* eslint-disable-line */
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

  if (!results) return false;
  return true
}

export function getParameterByName(name:String, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&'); /* eslint-disable-line */
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}